import React, {useEffect, useState} from 'react';
import CircularLoader from "../Common/CircularLoader";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import {TablePagination} from "@mui/material";
import {AllVasService} from "../../services/AllVasServices";
import UserTransactionListForModule from "./UserTransactionListForModule";

interface InputProps {
    vasMappingId: number
}

const allVasService = new AllVasService();

const VasMappingTransactionsTab = (props: InputProps) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    let [subData, setSubData] = useState<any>(null);
    let [isLoading, setIsLoading] = useState<boolean>();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const refreshData = (vasMappingId: number, limit: number, offset: number) => {
        setIsLoading(true)
        allVasService.getAllVasUserTransactionsForServiceMapping(vasMappingId, limit, offset)
            .then((data) => {
                setSubData(data);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            })
    }

    useEffect(() => {

        const refreshData = (vasMappingId: number, limit: number, offset: number) => {
            setIsLoading(true)
            allVasService.getAllVasUserTransactionsForServiceMapping(vasMappingId, limit, offset)
                .then((data) => {
                    setSubData(data);
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                })
        }

        refreshData(props.vasMappingId, rowsPerPage, page*rowsPerPage);
    }, [props.vasMappingId, rowsPerPage, page])

    return (
        <div>
            {
                isLoading ?
                    <CircularLoader/>
                    :
                    <div>
                        {
                            subData &&
                            subData.data &&
                            Array.isArray(subData.data) &&
                            (
                                subData.data.length>0 ?
                                    <UserTransactionListForModule
                                        data={subData?.data}
                                        refresh={() => refreshData(props.vasMappingId, rowsPerPage, page*rowsPerPage)}
                                    />
                                    :
                                    <EmptyListPlaceholder
                                        message='No Vas Transaction found'
                                    />
                            )
                        }
                        <TablePagination
                            component="div"
                            count={subData?.total || 0}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
            }
        </div>
    );
};

export default VasMappingTransactionsTab;
